export default __webpack_public_path__ + "static/media/element_banner_sale_all.c3e126bd.png";